import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap';

import {
  whatsappQrGet,
  whatsappQrUpdate
} from '../../../store/slices/tenantSlices/configurationSlice';
import CallexLoader from '../../../components/CallexLoader';
import { socket } from '../../../config/Socket';

const AddEditWhatsappModal = ({ isOpen, onCloseClick, isEdit = false, editRecord = null }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isScanning, setIsScanning] = useState(false);
  const [isQrFailed, setIsQrFailed] = useState(false);
  const [qrUrl, setQrUrl] = useState(null);

  const dispatch = useDispatch();

  const onChangePhoneNumber = async () => {
    setIsLoading(true);
    try {
      const payload = { isChangeNumber: true, id: editRecord.id };
      const response = await dispatch(whatsappQrUpdate(payload)).unwrap();
      if (response?.success) {
        setQrUrl(response?.qr);
        setIsQrFailed(false);
      } else {
        toast.error(response.error);
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchQr = async () => {
    setIsLoading(true);
    try {
      const response = await dispatch(whatsappQrGet()).unwrap();
      if (response?.success) {
        setQrUrl(response?.qr);
        setIsQrFailed(false);
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isEdit) {
      onChangePhoneNumber();
    } else {
      fetchQr();
    }
  }, [isEdit, editRecord]);

  useEffect(() => {
    const handleScan = (message) => {
      console.log('message---------->', message);
      setIsScanning(message?.status === 'scanning' ? true : false);
      if (message?.status === 'scanning-complete') {
        onCloseClick(true);
      } else if (message?.status === 'QR-failed') {
        setIsQrFailed(true);
      }
    };

    socket.on('whatsapp-notify', handleScan);
    return () => {
      socket.off('whatsapp-notify', handleScan);
    };
  }, [isEdit, editRecord, isOpen]);

  return (
    <Modal isOpen={isOpen} size="md" centered>
      <ModalHeader className="justify-content-center py-2">
        <div className="fs-5">Scan below QR code</div>
      </ModalHeader>
      <ModalBody className="px-4">
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center">
            <CallexLoader />
          </div>
        ) : (
          <Row>
            <Col lg="12" md="12" className="d-flex justify-content-center align-items-center">
              {isQrFailed ? (
                <div
                  className="d-flex justify-content-center align-items-center flex-column gap-2 cursor-pointer"
                  style={{
                    border: '3px solid var(--cx-accent)',
                    padding: '10px',
                    borderRadius: '4px',
                    height: '250px',
                    width: '250px'
                  }}
                  onClick={() => {
                    if (isEdit) {
                      onChangePhoneNumber();
                    } else {
                      fetchQr();
                    }
                  }}>
                  <i
                    className="bi bi-arrow-clockwise"
                    style={{ fontSize: '100px', lineHeight: '100px' }}></i>
                  <span>Refresh</span>
                </div>
              ) : (
                <img
                  src={`https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(
                    qrUrl
                  )}&size=250x250`}
                  alt="QR Code"
                  style={{ border: '3px solid var(--cx-accent)', padding: '10px', borderRadius: '4px' }}
                />
              )}
            </Col>
          </Row>
        )}
      </ModalBody>
      <ModalFooter className="d-flex justify-content-center align-items-center">
        <Button onClick={() => onCloseClick(false)} className="px-5 bg-transparent text-primary">
          Cancel
        </Button>
        <Button
          form="whatsapp"
          className="px-5 bg-primary border-primary"
          onClick={() => onCloseClick(true)}
          disabled={isScanning}>
          Continue
          {isScanning ? <Spinner size="sm" color="light" /> : null}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

AddEditWhatsappModal.propTypes = {
  isOpen: PropTypes.bool,
  isEdit: PropTypes.bool,
  onCloseClick: PropTypes.func,
  editRecord: PropTypes.any
};

export default AddEditWhatsappModal;
